const {debounce} = require('./Debounce');

class FixedHeaderBehavior {
    /**
     * @param {object} config - The configuration object.
     * @param {string} config.selector - the article fixed header selector
     * @param {string} config.boundingClientSelector - the element at which end we will change the header status
     * @param {boolean} config.hideOnScroll - if we want to hide the article header on content scrolling
     * @param {boolean} config.removeFixedStatus - if we want to remove the fixed status from the article header completely.
     *
     * @param {object} classes - the configuration object with the classnames
     * @param {string} classes.FIXED - fixed class
     * @param {string} classes.JS_HIDDEN - hidden class
     * @param {string} classes.JS_VISIBLE - visible class
     */
    constructor(config, classes) {
        this.config = config;
        this.s = classes;
        this.header = document.querySelectorAll(config.selector);
        if (this.header.length === 0) return;

        this._removeFixedStatus();
    }

    /**
     * @param {object} stickyHeader - the element we want to become sticky while scrolling
     * @param {object} [articleView] - the article element provided from ArticleView.js
     * @param {function} [callback] - any extra functionality we want to run afterward
     */
    trackWindowScroll(stickyHeader, articleView, callback) {
        debounce(this._controlFixedHeaderVisibility(stickyHeader, articleView), 250, true);
        callback && debounce(callback(), 250);
    }

    _removeFixedStatus() {
        if (!this.config.removeFixedStatus) return;
        this.header.forEach(headerItem => {
            headerItem.classList.remove(this.s.FIXED);
            headerItem.style.setProperty('position', 'relative', 'important');
            headerItem.style.setProperty('top', '0');
        });
    }

    /**
     * @param {object} stickyHeader - the element we want to become sticky while scrolling
     * @param {object} [articleView] - the article element provided from ArticleView.js
     */
    _controlFixedHeaderVisibility(stickyHeader, articleView) {
        if (!stickyHeader) return false;

        let {bottom} = (
            articleView.querySelector(this.config.boundingClientSelector) ||
            document.body.querySelector(this.config.boundingClientSelector)
        )?.getBoundingClientRect();
        const isVisible = stickyHeader.classList.contains(this.s.JS_VISIBLE);
        const height = this.header[0] ? this.header[0].offsetHeight : 0;

        bottom += this.config.boundingSpacer;

        if (bottom - height < 0 && !isVisible) {
            setTimeout(() => {
                this.config.hideOnScroll &&
                    this.header?.forEach(headerItem => headerItem.classList.add(this.s.JS_HIDDEN));
                stickyHeader.classList.add(this.s.JS_VISIBLE);
            }, 0);
        }

        if (bottom - height >= 0 && isVisible) {
            setTimeout(() => {
                this.config.hideOnScroll &&
                    this.header?.forEach(headerItem => headerItem.classList.remove(this.s.JS_HIDDEN));
                stickyHeader.classList.remove(this.s.JS_VISIBLE);

                try {
                    if (jQuery && !!stickyHeader.querySelector('[data-toggle="dropdown"]')) {
                        jQuery('[data-toggle="dropdown"]').dropdown?.('hide');
                    }
                } catch (error) {
                    console.error('Hide dropdowns failed', error);
                }
            }, 250);
        }

        return true;
    }
}

module.exports = FixedHeaderBehavior;
